<script lang="ts">
  // A skill's line icon on a bordered tile; one look in the sidebar, the detail and the cards.
  import { cn } from "$lib/utils.js";
  import { skillIconOption } from "./skill-icons.js";

  interface Props {
    // Absent is the default icon (a skill saved before icons existed).
    icon: string | undefined;
    size?: "sm" | "md" | "lg";
    class?: string;
  }

  let { icon, size = "sm", class: className = "" }: Props = $props();

  const option = $derived(skillIconOption(icon));
  const BOX = { sm: "size-8 rounded-lg", md: "size-10 rounded-lg", lg: "size-14 rounded-xl" };
  const GLYPH = { sm: "size-4", md: "size-[18px]", lg: "size-6" };
</script>

<span
  class={cn("flex shrink-0 items-center justify-center border border-edge bg-surface text-content-dim", BOX[size], className)}
  aria-hidden="true"
>
  <option.icon class={GLYPH[size]} />
</span>
